import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Input, List } from 'semantic-ui-react';
import { useStore } from '../../stores/store';
import HistoryPagination from '../../../features/MediaAssets/Details/HistoryDetails/pagination/HistoryPagination';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import ImageTag from '../../../features/Profile/RenderImage';
import { assignUserType } from '../../api/types';

export default observer(function MyAddUser() {
  const {
    activityStore: { selectedActivity: activity },
    commonStore,
    viewStore: {
      getUnAssignedUsersAlone,
      unAssignedUsersCount,
      getUnAssignedUsers,
      unAssignedUsers,
      addUserToItem,
      getAssignedUsers,
    },
  } = useStore();
  const [userFilter, setUserFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 768) {
      getUnAssignedUsers({
        itemId: activity?.id,
        displayName: '',
        pageNo: 1,
        pageSize: 5,
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    getUnAssignedUsers({
      itemId: activity?.id,
      displayName: userFilter,
      pageNo: 1,
      pageSize: 5,
    });
    // eslint-disable-next-line
  }, [userFilter]);

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    getUnAssignedUsersAlone({
      itemId: activity?.id,
      displayName: '',
      pageNo: pageNumber,
      pageSize: 5,
    });
  };

  const assignUser = async (user: assignUserType) => {
    await addUserToItem(
      { itemId: activity?.id, userId: user.id },
      user.displayname,
      false,
    );
    await getAssignedUsers({ itemId: activity?.id });
    await getUnAssignedUsers({
      itemId: activity?.id,
      displayName: '',
      pageNo: 1,
      pageSize: 5,
    });
  };

  // if (unAssignUserLoader) return <LoadingComponent />;

  return (
    <div className="myadduser-search-parent">
      <div className="user-input-search">
        <Input
          fluid
          icon="search"
          placeholder={
            (
              userLanguage[0].AssetsViewItemLevelViewPageUsersAssignedSegment
                ?.AVILVPUASTB01 as any
            )?.[`${commonStore.language.key}`]
          } //"Search..."
          onChange={(event) => setUserFilter(event.target.value)}
          value={userFilter}
        />
      </div>
      <List divided verticalAlign="middle">
        <>
          {unAssignedUsers?.map((user) => (
            <List.Item key={user.id}>
              <List.Content floated="right">
                {commonStore.filterModeTwo?.includes('AVLAVB09') ? (
                  <></>
                ) : (
                  <Button
                    onClick={() => assignUser(user)}
                    disabled={commonStore.filterModeZero?.includes('AVLAVB09')}
                    //Add
                  >
                    {
                      (
                        userLanguage[0]
                          .AssetsViewItemLevelViewPageUsersAssignedSegment
                          ?.AVILVPUASB01 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </Button>
                )}
              </List.Content>
              <ImageTag
                avatar={true}
                imageUrl={user?.image}
                defaultUrl="/assets/user.png"
              />
              <List.Content>{user.displayname}</List.Content>
            </List.Item>
          ))}
        </>
      </List>
      <HistoryPagination
        className="pagination-bar"
        currentPage={currentPage || 1}
        totalCount={unAssignedUsersCount}
        pageSize={postsPerPage}
        onPageChange={paginate}
      />
    </div>
  );
});
